import { ConfigurationService } from 'src/app/shared/services/configuration.service'
import { Component, Input, Output, EventEmitter } from '@angular/core'
import { combineLatest, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { AppRoutesNS } from 'src/app/app-routes.namespace'
import { Member, MemberStatus } from 'src/app/features/member/member'
import { TicketingService } from 'src/app/features/shop/ticketing/ticketing.service'
import { ModuleConfigs } from 'src/environments/environment-model'

@Component({
  selector: 'primary-navbar-top-menu-block',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class PrimaryNavBarTopMenuComponent {
  @Input() member$!: Observable<Member>
  @Input() hasEmployeeOrSupervisorRole$!: Observable<boolean>
  @Input() moduleConfigs: ModuleConfigs
  @Input() showCartButton = true

  @Output() userRoleSwitcher = new EventEmitter<boolean>()
  @Output() ticketingReset = new EventEmitter<void>()
  @Output() logout = new EventEmitter<void>()
  @Output() goLogin = new EventEmitter<void>()
  public appRoutesNS = AppRoutesNS

  constructor(
    public ticketingservice: TicketingService,
    public configurationService: ConfigurationService
  ) {}

  setShowUserRoleSwithcher(value: boolean) {
    this.userRoleSwitcher.emit(value)
  }
  public showMyShoppingInMobile$(): Observable<boolean> {
    return this.configurationService.isRouteAllowedOnMobileApp$(
      AppRoutesNS.Members.PROFILE_MYSHOPPING
    )
  }

  public showShopInMobile$(): Observable<boolean> {
    return combineLatest([
      this.configurationService.isRouteAllowedOnMobileApp$(
        AppRoutesNS.Shop.SHOP,
        this.moduleConfigs.shopModule.isActive
      ),
      this.configurationService.isTabletOrLarger$
    ]).pipe(
      map(
        ([isRouteAllowedOnMobileApp, isTabletOrLarger]) =>
          isRouteAllowedOnMobileApp && !isTabletOrLarger
      )
    )
  }

  public showMyWorkInMobile$(): Observable<boolean> {
    return combineLatest([
      this.configurationService.isRouteAllowedOnMobileApp$(
        AppRoutesNS.MyWork.MY_WORK
      ),
      this.configurationService.isTabletOrLarger$,
      this.hasEmployeeOrSupervisorRole$,
      this.member$
    ]).pipe(
      map(
        ([
          isRouteAllowedOnMobileApp,
          isTabletOrLarger,
          hasEmployeeOrSupervisorRole,
          member
        ]) =>
          isRouteAllowedOnMobileApp &&
          !isTabletOrLarger &&
          (this.moduleConfigs.employeeModule.isActive ||
            this.moduleConfigs.supervisorModule.isActive) &&
          hasEmployeeOrSupervisorRole &&
          Boolean(member) &&
          member.status !== MemberStatus.GUEST
      )
    )
  }
}
